import gql from 'graphql-tag';

export default gql`

fragment UserFields on User {
    id
    email
    fname
    lname
    nickname
    photo_url
    thumbnail_url
    default_gym_id
    achievement_id
    slug
    date_created
    stripe_source_id
    stripe_last4
    stripe_source_status
    stripe_customer_id
    stripe_source_email
    bio
}

`;
